(function() {
  angular.module('cfn').factory('Seed', Seed);

  Seed.$inject = ['dataSource.factory'];

  function Seed(dataSource) {
    return dataSource('seed').getRestService();
  }
})();
